import React from 'react';
import { useTranslation } from 'react-i18next';

export default function NewBadge({ releasedOn }) {
  const { t } = useTranslation();
  const age = Date.now() - Date.parse(releasedOn);

  if (age < 0 || age >= 30 * 24 * 60 * 60 * 1000) {
    return null;
  }

  return (
    <div
      style={{
        background: '#dbeafe',
        borderRadius: 3,
        padding: '1px 3px',
        marginLeft: 8,
        fontSize: 10,
        color: '#1e40af',
        fontWeight: 500,
        textTransform: 'uppercase',
      }}
    >
      {t('global.new')}
    </div>
  );
}
